import React from 'react';
import PropTypes from 'prop-types';
import withInit from 'WithInit';
import Banner from 'Banner';

const MembersAreaReactivationBanner = ({ page }) => {
  const trackAndRedirect = () => {
    window._track('Reactivate Banner', page);
    window.location.assign('/my-account?subscription_settings_scroll=1');
  };

  return (
    <Banner
      isCloseable={false}
    >
      <div className="members-area-reactivation-banner">
        <button onClick={trackAndRedirect}>
          Reactivate
        </button>
        &nbsp;your account today to export your documents!
      </div>
    </Banner>
  );
};

MembersAreaReactivationBanner.propTypes = {
  page: PropTypes.string.isRequired,
};

export default withInit(MembersAreaReactivationBanner);



// WEBPACK FOOTER //
// ./src-react/ReactivationBanner/MembersAreaReactivationBanner.jsx